import { FC, useCallback } from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import FormTextField from '@components/FormTextField/FormTextField';
import ModalForm from '@components/ModalForm/ModalForm';
import { IAdminProgramCodeDrugClass } from '@interfaces/adminProgramCodes';

import { IFormDrugClassesModalProps } from './FormDrugClassesModal.interface';

import './style.scss';

const formId = 'admin-drug-class-modal';

const FormDrugClassesModal: FC<IFormDrugClassesModalProps> = ({
  open,
  currentItem,
  onApply,
  onClose,
  onExited,
}) => {
  const { t } = useTranslation();

  const handleValidate = useCallback((item: IAdminProgramCodeDrugClass) => {
    const errors: Partial<Record<keyof IAdminProgramCodeDrugClass, string | boolean>> = {};
    if (!item.name) errors.name = true;
    return errors;
  }, []);

  const handleSubmit = useCallback(
    (item: IAdminProgramCodeDrugClass) => {
      onApply(item);
      onClose();
    },
    [onApply, onClose],
  );

  return (
    <ModalForm<IAdminProgramCodeDrugClass>
      onClose={onClose}
      onExited={onExited}
      open={open}
      formId={formId}
      title={currentItem ? t('admin.editDrugClass') : t('admin.addNewDrugClass')}
      className="form-drug-classes-modal"
      leftActionTitle={t('common.cancel')}
      onLeftAction={onClose}
      rightActionTitle={t('admin.submit')}
      initialValues={currentItem}
      validate={handleValidate}
      onSubmit={handleSubmit}
    >
      {({ handleSubmit }) => (
        <form id={formId} onSubmit={handleSubmit}>
          <Field component={FormTextField} label={t('admin.drugClassName')} name="name" required />
        </form>
      )}
    </ModalForm>
  );
};

export default FormDrugClassesModal;
